if (!customElements.get('lux-delivery-block')) {
  customElements.define('lux-delivery-block', class LuxDeliveryBlock extends HTMLElement {
    constructor() {
      super();
      this.locale = this.getAttribute('data-locale') ? this.getAttribute('data-locale').toUpperCase() : 'RS';
      
      this.window = this.querySelector('.lux-delivery-block__window');
      this.timerMsg = this.querySelector('.lux-delivery-block__window-message');
      this.closedMsg = this.querySelector('.lux-delivery-block__window-message-closed');
      this.shippingMsg = this.querySelector('.lux-delivery-block__message-shipping');
      
      this.elements = {
        orderDay: this.querySelector('.lux-delivery-block__column-day.order'),
        orderWeekday: this.querySelector('.lux-delivery-block__column-weekday.order'),
        shippingDay: this.querySelector('.lux-delivery-block__column-day.shipping'),
        shippingWeekday: this.querySelector('.lux-delivery-block__column-weekday.shipping'),
        deliveryDay: this.querySelector('.lux-delivery-block__column-day.delivery'),
        deliveryWeekday: this.querySelector('.lux-delivery-block__column-weekday.delivery')
      };

      this.templateBefore = this.timerMsg ? this.timerMsg.textContent : "Još {time} za slanje danas";
      this.templateAfter = this.closedMsg ? this.closedMsg.textContent : "Vaša pošiljka će biti poslata u {day}";
      
      this.dayNames = ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"];
      this.dayNamesAccusative = ["nedelju", "ponedeljak", "utorak", "sredu", "četvrtak", "petak", "subotu"];
      this.monthNames = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"];
    }

    connectedCallback() {
      const head = this.querySelector('.lux-delivery-block__head');
      if (head) head.addEventListener('click', () => this.toggleAccordion());

      this.updateUI();
      this.timerInterval = setInterval(() => this.updateUI(), 60000);
    }

    disconnectedCallback() {
      clearInterval(this.timerInterval);
    }

    toggleAccordion() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
    }

    formatDate(date) {
      return `${date.getDate()}.${date.getMonth() + 1}.`;
    }

    formatDateWithMonth(date) {
      return `${date.getDate()}. ${this.monthNames[date.getMonth()]}`;
    }

    updateUI() {
      const now = new Date();
      const day = now.getDay(); 
      const hour = now.getHours();
      const cutoffHour = 13;

      // SHIPPING MESSAGE VISIBILITY
      if (this.shippingMsg) {
        const isPastCutoff = hour >= cutoffHour;
        const isWeekendOrFriday = (day === 5 || day === 6 || day === 0);

        this.shippingMsg.classList.toggle('is-hidden', isPastCutoff || isWeekendOrFriday);
      }

      // WINDOW VISIBILITY
      const shippingToday = (hour < cutoffHour) && (day !== 0 && day !== 6);

      if (this.window) {
        this.window.classList.toggle('is-hidden', !shippingToday);
      }

      if (shippingToday) {
        this.renderTimer(now, cutoffHour);
      } else {
        this.renderClosedMessage(day);
      }

      // --- MIDDLE COLUMN LOGIC (SHIPPING) ---
      let shipDate = new Date(now);
      shipDate.setDate(now.getDate() + 1);

      while(shipDate.getDay() === 0 || shipDate.getDay() === 6) {
        shipDate.setDate(shipDate.getDate() + 1);
      }

      const { orderDay, orderWeekday, shippingDay, shippingWeekday, deliveryDay, deliveryWeekday } = this.elements;

      if (orderDay) orderDay.textContent = "Danas";
      if (orderWeekday) orderWeekday.textContent = `(${this.dayNames[day]})`;

      if (shippingDay && shippingWeekday) {
        const todayReset = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        const shipReset = new Date(shipDate.getFullYear(), shipDate.getMonth(), shipDate.getDate()).getTime();
        const daysDiff = Math.round((shipReset - todayReset) / (1000 * 60 * 60 * 24));

        if (daysDiff === 1) {
          shippingDay.textContent = "Sutra";
        } else {
          shippingDay.textContent = this.formatDate(shipDate);
        }

        shippingWeekday.textContent = `(${this.dayNames[shipDate.getDay()]})`;
      }

      // --- DELIVERY COLUMN LOGIC ---
      if (this.locale === 'ME' || this.locale === 'BIH') {
        if (deliveryDay) deliveryDay.textContent = "Dostava";
        if (deliveryWeekday) deliveryWeekday.textContent = "za 5 do 7 radnih dana";
      } else {
        let rangeText = "";
        let daysToLastDay = 0;
        const sDay = shipDate.getDay();

        switch(sDay) {
          case 1: rangeText = "Utorak - Sreda"; daysToLastDay = 2; break;
          case 2: rangeText = "Sreda - Četvrtak"; daysToLastDay = 2; break;
          case 3: rangeText = "Četvrtak - Petak"; daysToLastDay = 2; break;
          case 4: rangeText = "Petak - Ponedeljak"; daysToLastDay = 4; break;
          case 5: rangeText = "Ponedeljak - Utorak"; daysToLastDay = 4; break;
        }

        let lastDeliveryDate = new Date(shipDate);
        lastDeliveryDate.setDate(shipDate.getDate() + daysToLastDay);

        if (deliveryDay) {
          deliveryDay.textContent = `Do ${this.formatDateWithMonth(lastDeliveryDate)}`;
        }
        if (deliveryWeekday) {
          deliveryWeekday.textContent = `(${rangeText})`;
        }
      }
    }

    renderTimer(now, cutoff) {
      const target = new Date(now);
      target.setHours(cutoff, 0, 0, 0);

      const diffMs = target - now;
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      if (this.timerMsg) {
        this.timerMsg.classList.remove('is-hidden');
        this.timerMsg.innerHTML =
          this.templateBefore.replace('{time}', `<span class="countdown">${hours}h:${minutes}m</span>`);
      }

      if (this.closedMsg) {
        this.closedMsg.classList.add('is-hidden');
      }
    }

    renderClosedMessage(day) {
      let shipDayIdx = (day + 1) % 7;
      if (day === 5 || day === 6 || day === 0) shipDayIdx = 1;

      if (this.closedMsg) {
        this.closedMsg.classList.remove('is-hidden');
        this.closedMsg.textContent =
          this.templateAfter.replace('{day}', this.dayNamesAccusative[shipDayIdx]);
      }

      if (this.timerMsg) {
        this.timerMsg.classList.add('is-hidden');
      }
    }
  });
}